export default __webpack_public_path__ + "static/media/joe.3d515edf.png";